import { createWrapSafe } from '@/scopes/wrappers/createWrapSafe.js';

export const createWrapBasic = createWrapSafe;